import sharedFilters from './shared';

export default {
  pageFilters: [
    {
      label: 'Content',
      id: 'content',
      filters: {
        show: null,
        gem_survey_season: null,
        network: null,
        genre: null,
        cancel_status: null
      }
    },
    {
      id: 'segments',
      label: 'Saved Filters',
      filters: {
        segments: sharedFilters.segments
      }
    }
  ],
  looks: {
    gemReport: {
      fields: [
        'cancel_status',
        'gem_survey_season',
        'network',
        'genre',
        'show'
      ],
      showTitle: true
    }
  }
};
